import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=00b03f4a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=00b03f4a&prod&lang=scss&scoped=true"
import style1 from "./Footer.vue?vue&type=style&index=1&id=00b03f4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b03f4a",
  null
  
)

export default component.exports